import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteEvent as deleteEventApi} from "../services/apiEvents.js";


export function useDeleteEvent() {
    const queryClient = useQueryClient();
    const {isLoading : isDeleting, mutate: deleteEvent} = useMutation({
        mutationFn: deleteEventApi,
        onSuccess: () => {
            console.log("Event deleted successfully");
            alert ("Event deleted successfully");
            queryClient.invalidateQueries({
                queryKey: ["events"],
            });
        },
        onError: (error) => {
            console.error("Error deleting event:", error);
            alert("Error deleting event: " + error.message);
        },
    });
    
    return {isDeleting, deleteEvent};
}

